import React, { useState } from "react";
import {
  FaEnvelope,
  FaEye,
  FaEyeSlash,
  FaUser,
  FaFlag,
  FaPhone,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import apis from "../services";
import { showApiErrors } from "../utils";

function Signup() {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    password: "",
    confirmPassword: "",
    deviceId: "",
  });
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      let deviceId = localStorage.getItem("deviceId");
      console.log("first", deviceId);
      if (!deviceId) {
        deviceId = crypto.randomUUID();
        localStorage.setItem("deviceId", deviceId);
        console.log("second", deviceId);
        // setForm((prev) => ({
        //   ...prev,
        //   deviceId: deviceId,
        // }));
      }

      const res = await apis.authSignupReq({ ...form, deviceId: deviceId });
      // console.log(res.data, "---");
      // localStorage.setItem('token', res.data.token);
      // localStorage.setItem('refreshToken', res.data.refreshToken);
      setLoading(false);
      navigate("/two-step-verification", {
        state: { email: res?.data?.email },
        replace: true,
      });
    } catch (error) {
      setLoading(false);
      showApiErrors(error, "Signup failed, please try again");
    }
  };

  return (
    <div className="login-background">
      <div className="header-container">
        <div className="header-content">
          <h2 className="header-subtitle">
            <span className="color-sp-lookna"> Lookna </span>
            <br></br>
            <br></br>
            FIND YOUR<span className="color-sp"> IDEAL INVESTMENT </span>VAULT
          </h2>
        </div>
        <div className="details-borders"></div>
        <br></br>
      </div>

      <div className="login-box">
        <h3 className="login-heading">Create Account</h3>
        <form className="login-form" onSubmit={handleSubmit}>
          <div className="input-group">
            <FaUser className="input-icon" />
            <input
              type="text"
              name="firstName"
              placeholder="First Name"
              className="input-field"
              required
              value={form.firstName}
              onChange={handleChange}
            />
          </div>
          <div className="input-group">
            <FaUser className="input-icon" />
            <input
              type="text"
              name="lastName"
              placeholder="Last Name"
              className="input-field"
              required
              value={form.lastName}
              onChange={handleChange}
            />
          </div>
          <div className="input-group">
            <FaEnvelope className="input-icon" />
            <input
              type="email"
              name="email"
              placeholder="Email"
              className="input-field"
              required
              value={form.email}
              onChange={handleChange}
            />
          </div>
          <div className="input-group">
            <FaPhone className="input-icon" />
            <input
              type="text"
              name="phoneNumber"
              placeholder="Mobile Number"
              className="input-field"
              required
              value={form.phoneNumbere}
              onChange={handleChange}
            />
          </div>

          <div className="input-group">
            <span
              onClick={() => setPasswordVisible(!passwordVisible)}
              className="password-toggle-icon"
            >
              {passwordVisible ? (
                <FaEye className="input-icon" />
              ) : (
                <FaEyeSlash className="input-icon" />
              )}
            </span>
            <input
              type={passwordVisible ? "text" : "password"}
              name="password"
              placeholder="Password"
              className="input-field"
              required
              value={form.password}
              onChange={handleChange}
            />
          </div>
          <div className="input-group">
            <span
              onClick={() => setConfirmPasswordVisible(!confirmPasswordVisible)}
              className="password-toggle-icon"
            >
              {confirmPasswordVisible ? (
                <FaEye className="input-icon" />
              ) : (
                <FaEyeSlash className="input-icon" />
              )}
            </span>
            <input
              type={confirmPasswordVisible ? "text" : "password"}
              name="confirmPassword"
              placeholder="Confirm Password"
              className="input-field"
              required
              value={form.confirmPassword}
              onChange={handleChange}
            />
          </div>
          <button
            type="submit"
            className="login-button"
            disabled={loading}
            style={{
              position: "relative",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              cursor: loading ? "not-allowed" : "pointer",
              opacity: loading ? 0.7 : 1,
            }}
          >
            {loading ? "Creating..." : "Create Account"}
          </button>
        </form>
        <div style={{ marginTop: 16 }}>
          {/* <button
            className="login-button"
            style={{ background: '#fff', color: '#111', fontWeight: 600, marginBottom: 8 }}
            onClick={() => toast.info('Continue with Google (mocked)')}
          >
            <img src="https://img.icons8.com/color/16/000000/google-logo.png" alt="Google" style={{ marginRight: 8 }} />
            Continue With Google
          </button> */}
          <div style={{ color: "#aaa", marginTop: 8 }}>
            Already Have An Account?{" "}
            <span
              style={{ color: "#BE6BED", cursor: "pointer" }}
              onClick={() => navigate("/")}
            >
              Log In
            </span>
          </div>
        </div>
      </div>
      <br></br>
    </div>
  );
}

export default Signup;
